import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const weightChangeLbs: AnswerPathTreeNode = {
  path: 'weightChangeLbs',
  nodeId: NodeIds.insuredWeightChangeOfLbs,
};
